import React from 'react'

const AboutBanner = () => {
    return (
        <div className='about-banner'>
            <div className='content'>
                <div className='title'><h1>Creating an impact requires a team with sharp minds and strategic thinking.</h1></div>
                <div className='subtitle'><span>Liberyus is a boutique software solutions agency specializing in creating cutting-edge mobile applications, intuitive UI/UX designs, modern web designs, and impactful branding strategies. We combine innovation and creativity to deliver seamless digital experiences tailored to meet the unique needs of our clients.</span></div>
            </div>
        </div>
    )
}

export default AboutBanner
